import { render, staticRenderFns } from "./auth_email.vue?vue&type=template&id=2fc2627f&scoped=true&"
import script from "./auth_email.vue?vue&type=script&lang=js&"
export * from "./auth_email.vue?vue&type=script&lang=js&"
import style0 from "./auth_email.vue?vue&type=style&index=0&id=2fc2627f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2627f",
  null
  
)

export default component.exports